import { useEffect, useMemo, useRef, useState } from 'react';

import { useLocation } from 'react-router-dom';
import { IconTypeKey, NavRouteType } from '../types';
import { getActiveRouteMenuKey } from '../utils/matchActiveRoute';
import { useHistory } from '@mindtickle/ui-shell-core/BrowserRouter';

const useNavMenuData = ({
  linkPattern,
  subMenu,
}: {
  linkPattern: string;
  subMenu: NavRouteType[];
}) => {
  const routeActiveKeyRef = useRef<boolean | string>('');
  const history = useHistory();
  const openMenuByManualClickRef = useRef(false);
  const [isMenuOpen, setMenuOpen] = useState(false);

  const { pathname, search } = useLocation();
  routeActiveKeyRef.current = useMemo(
    () =>
      getActiveRouteMenuKey({
        subMenu,
        pathname,
        linkPattern,
        search,
      }),
    [pathname, subMenu, linkPattern, search]
  );

  const iconTypeKey: IconTypeKey = routeActiveKeyRef.current ? 'filled' : 'light';

  const onMenuExpandHandler = ({ firstSubMenu }: { firstSubMenu: string }) => {
    if (firstSubMenu) {
      history.push(firstSubMenu);
    }
    if (isMenuOpen) return;
    setMenuOpen(true);
  };

  useEffect(() => {
    if (!routeActiveKeyRef.current) {
      setMenuOpen(false);
    } else {
      setMenuOpen(true);
    }
  }, [pathname]);

  return {
    pathname,
    isMenuOpen,
    iconTypeKey,
    onMenuExpandHandler,
    activeRouteId: routeActiveKeyRef.current,
    isMenuOpenByManualClick: openMenuByManualClickRef.current,
  };
};

export default useNavMenuData;
